{
  "labels": {
    "paste": "הדבק",
    "pasteAsPlaintext": "הדבק ללא עיצוב",
    "pasteCharts": "הדבק גרפים",
    "selectAll": "בחר הכל",
    "multiSelect": "הוסף רכיב לבחירה",
    "moveCanvas": "הזז את הקנבס",
    "cut": "גזור",
    "copy": "העתק",
    "copyAsPng": "העתק ללוח כ PNG",
    "copyAsSvg": "העתק ללוח כ SVG",
    "copyText": "העתק ללוח כטקסט",
    "copySource": "",
    "convertToCode": "",
    "bringForward": "הבא שכבה קדימה",
    "sendToBack": "שלח אחורה",
    "bringToFront": "העבר לחזית",
    "sendBackward": "העבר שכבה אחורה",
    "delete": "מחק",
    "copyStyles": "העתק סגנון",
    "pasteStyles": "הדבק סגנון",
    "stroke": "קו מתאר",
    "background": "רקע",
    "fill": "מילוי",
    "strokeWidth": "עובי קו מתאר",
    "strokeStyle": "סגנון קו המתאר",
    "strokeStyle_solid": "מלא",
    "strokeStyle_dashed": "מקווקו",
    "strokeStyle_dotted": "מנוקד",
    "sloppiness": "רישול",
    "opacity": "אטימות",
    "textAlign": "יישור טקסט",
    "edges": "קצוות",
    "sharp": "חד",
    "round": "עגול",
    "arrowheads": "ראשי חצים",
    "arrowhead_none": "ללא",
    "arrowhead_arrow": "חץ",
    "arrowhead_bar": "קצה אנכי",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "משולש",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "גודל גופן",
    "fontFamily": "גופן",
    "addWatermark": "הוסף \"נוצר באמצעות Excalidraw\"",
    "handDrawn": "ציור יד",
    "normal": "רגיל",
    "code": "קוד",
    "small": "קטן",
    "medium": "בינוני",
    "large": "גדול",
    "veryLarge": "גדול מאוד",
    "solid": "מוצק",
    "hachure": "קווים מקבילים קצרים להצגת כיוון וחדות שיפוע במפה",
    "zigzag": "זיגזג",
    "crossHatch": "קווים מוצלבים שתי וערב",
    "thin": "דק",
    "bold": "מודגש",
    "left": "שמאל",
    "center": "מרכז",
    "right": "ימין",
    "extraBold": "מודגש במיוחד",
    "architect": "ארכיטקט",
    "artist": "אמן",
    "cartoonist": "קריקטוריסט",
    "fileTitle": "שם קובץ",
    "colorPicker": "בוחר צבעים",
    "canvasColors": "בשימוש בקנבס",
    "canvasBackground": "רקע קנבס",
    "drawingCanvas": "קנבס ציור",
    "layers": "שכבות",
    "actions": "פעולות",
    "language": "שפה",
    "liveCollaboration": "התחל שיתוף חי...",
    "duplicateSelection": "שכפל",
    "untitled": "ללא כותרת",
    "name": "שם",
    "yourName": "שמך",
    "madeWithExcalidraw": "נוצר באמצעות Excalidraw",
    "group": "קבץ",
    "ungroup": "פרק קבוצה",
    "collaborators": "שותפים",
    "showGrid": "הצג רשת",
    "addToLibrary": "הוסף לספריה",
    "removeFromLibrary": "הסר מספריה",
    "libraryLoadingMessage": "טוען ספריה…",
    "libraries": "עיין בספריות",
    "loadingScene": "טוען תצוגה…",
    "align": "יישר",
    "alignTop": "יישר למעלה",
    "alignBottom": "יישר למטה",
    "alignLeft": "יישר לשמאל",
    "alignRight": "יישר לימין",
    "centerVertically": "מרכז אנכית",
    "centerHorizontally": "מרכז אופקית",
    "distributeHorizontally": "חלוקה אופקית",
    "distributeVertically": "חלוקה אנכית",
    "flipHorizontal": "הפוך אופקית",
    "flipVertical": "הפוך אנכית",
    "viewMode": "מצב תצוגה",
    "share": "שתף",
    "showStroke": "הצג בוחר צבע מברשת",
    "showBackground": "הצג בוחר צבע רקע",
    "toggleTheme": "שינוי ערכת העיצוב",
    "personalLib": "ספריה פרטית",
    "excalidrawLib": "הספריה של Excalidraw",
    "decreaseFontSize": "הקטן את גודל הגופן",
    "increaseFontSize": "הגדל את גודל הגופן",
    "unbindText": "ביטול קיבוע הטקסט",
    "bindText": "קיבוע הטקסט למיכל",
    "createContainerFromText": "ארוז טקסט במיכל",
    "link": {
      "edit": "עריכת קישור",
      "editEmbed": "ערוך קישור ושבץ",
      "create": "יצירת קישור",
      "createEmbed": "צור קישור ושבץ",
      "label": "קישור",
      "labelEmbed": "קשר ושבץ",
      "empty": "לא נקבע קישור"
    },
    "lineEditor": {
      "edit": "ערוך קו",
      "exit": "צא מעורך הקו"
    },
    "elementLock": {
      "lock": "נעילה",
      "unlock": "ביטול נעילה",
      "lockAll": "לנעול הכל",
      "unlockAll": "שחרור הכול"
    },
    "statusPublished": "פורסם",
    "sidebarLock": "שמור את סרגל הצד פתוח",
    "selectAllElementsInFrame": "בחר את כל האלמנטים במסגרת",
    "removeAllElementsFromFrame": "הסר את כל האלמנטים שבמסגרת",
    "eyeDropper": "",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "עוד לא הוספת דברים...",
    "hint_emptyLibrary": "בחר משהו בקנבס כדי להוסיף אותו לכאן, או שתתקין ספריה מהספריה הציבורית מטה.",
    "hint_emptyPrivateLibrary": "בחר משהו בקנבס כדי להוסיף אותו לכאן."
  },
  "buttons": {
    "clearReset": "אפס את הקנבאס",
    "exportJSON": "ייצא לקובץ",
    "exportImage": "ייצוא התמונה...",
    "export": "שמור ל...",
    "copyToClipboard": "העתק ללוח",
    "save": "שמור לקובץ נוכחי",
    "saveAs": "שמירה בשם",
    "load": "פתח",
    "getShareableLink": "קבל קישור לשיתוף",
    "close": "סגור",
    "selectLanguage": "בחר שפה",
    "scrollBackToContent": "גלול בחזרה לתוכן",
    "zoomIn": "הגדל",
    "zoomOut": "הקטן",
    "resetZoom": "איפוס זום",
    "menu": "תפריט",
    "done": "בוצע",
    "edit": "ערוך",
    "undo": "בטל",
    "redo": "בצע מחדש",
    "resetLibrary": "איפוס ספריה",
    "createNewRoom": "צור חדר חדש",
    "fullScreen": "מסך מלא",
    "darkMode": "מצב כהה",
    "lightMode": "מצב בהיר",
    "zenMode": "מצב זן",
    "objectsSnapMode": "",
    "exitZenMode": "צא ממצב זן",
    "cancel": "ביטול",
    "clear": "ניקוי",
    "remove": "הסר",
    "embed": "",
    "publishLibrary": "פרסום",
    "submit": "שליחה",
    "confirm": "אשר",
    "embeddableInteractionButton": ""
  },
  "alerts": {
    "clearReset": "פעולה זו תנקה את כל הקנבס. אתה בטוח?",
    "couldNotCreateShareableLink": "יצירת קישור לשיתוף נכשל.",
    "couldNotCreateShareableLinkTooBig": "יצירת קישור לשיתוף נכשל: התצוגה גדולה מדי",
    "couldNotLoadInvalidFile": "טעינת קובץ לא תקין נכשלה",
    "importBackendFailed": "ייבוא מהשרת נכשל.",
    "cannotExportEmptyCanvas": "לא ניתן לייצא קנבאס ריק.",
    "couldNotCopyToClipboard": "לא ניתן היה להעתיק ללוח.",
    "decryptFailed": "פיענוח ההצפנה של המידע נכשל.",
    "uploadedSecurly": "ההעלאה אובטחה באמצעות הצפנה מקצה לקצה, פירוש הדבר שהשרת של Excalidraw וגורמי צד ג׳ לא יכולים לקרוא את התוכן.",
    "loadSceneOverridePrompt": "טעינה של ציור חיצוני תחליף את התוכן הקיים שלך. האם תרצה להמשיך?",
    "collabStopOverridePrompt": "עצירת השיתוף תוביל למחיקת הציור הקודם ששמור מקומית בדפדפן. האם אתה בטוח?\n\n(אם תרצה לשמור את הציור המקומי, סגור את הטאב של הדפדפן במקום.)",
    "errorAddingToLibrary": "לא ניתן להוסיף פריט לספרייה",
    "errorRemovingFromLibrary": "לא ניתן להסיר פריט מהספריה",
    "confirmAddLibrary": "זה יוסיף {{numShapes}} צורה(ות) לספריה שלך. האם אתה בטוח?",
    "imageDoesNotContainScene": "נראה שהתמונה לא מכילה מידע על הסצינה. האם אפשרת הטמעת מידע הסצינה בעת השמירה?",
    "cannotRestoreFromImage": "לא הצלחנו לשחזר את הסצנה מקובץ התמונה",
    "invalidSceneUrl": "ייבוא מידע סצנה מהקישור שסופק כשל. או שהוא משובש, או שאינו מכיל מידע של Excalidraw בפורמט JSON.",
    "resetLibrary": "פעולה זו תנקה את כל הספריה שלך. אתה בטוח?",
    "removeItemsFromsLibrary": "מחק {{count}} פריט(ים) מהספריה?",
    "invalidEncryptionKey": "מפתח ההצפנה חייב להיות בן 22 תוים. השיתוף החי מנוטרל.",
    "collabOfflineWarning": "אין חיבור זמין לאינטרנט.\nהשינויים שלך לא ישמרו!"
  },
  "errors": {
    "unsupportedFileType": "סוג הקובץ אינו נתמך.",
    "imageInsertError": "לא ניתן היה להוסיף את התמונה. אנא נסה שוב מאוחר יותר...",
    "fileTooBig": "הקובץ גדול מדי. הגודל המירבי המותר הינו {{maxSize}}.",
    "svgImageInsertError": "לא ניתן היה להוסיף את תמונת ה-SVG. הסימונים בתוך קובץ ה-SVG עשויים להיות שגויים.",
    "failedToFetchImage": "",
    "invalidSVGString": "SVG שגוי.",
    "cannotResolveCollabServer": "לא הצלחתי להתחבר לשרת השיתוף. אנא רענן את הדף ונסה שוב.",
    "importLibraryError": "לא ניתן היה לטעון את הספריה",
    "collabSaveFailed": "לא הצלחתי להתחבר למסד הנתונים האחורי. אם הבעיה ממשיכה, כדאי שתשמור את הקובץ מקומית כדי לוודא שלא תאבד את העבודה שלך.",
    "collabSaveFailed_sizeExceeded": "לא הצלחתי לשמור למסד הנתונים האחורי, נראה שהקנבס שלך גדול מדי. כדאי שתשמור את הקובץ מקומית כדי לוודא שלא תאבד את העבודה שלך.",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "בחירה",
    "image": "הוספת תמונה",
    "rectangle": "מלבן",
    "diamond": "יהלום",
    "ellipse": "אליפסה",
    "arrow": "חץ",
    "line": "קו",
    "freedraw": "צייר",
    "text": "טקסט",
    "library": "ספריה",
    "lock": "השאר את הכלי הנבחר פעיל גם לאחר סיום הציור",
    "penMode": "מצב עט - מנע נגיעה",
    "link": "הוספה/עדכון קישור של הצורה שנבחרה",
    "eraser": "מחק",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "",
    "hand": "יד (כלי הזזה)",
    "extraTools": "",
    "mermaidToExcalidraw": "",
    "magicSettings": ""
  },
  "headings": {
    "canvasActions": "פעולות קנבאס",
    "selectedShapeActions": "פעולות על הצורות שנבחרו",
    "shapes": "צורות"
  },
  "hints": {
    "canvasPanning": "כדי להזיז את הקנבס, החזק את גלגל העכבר לחוץ או את מקש הרווח לחוץ תוך כדי גרירה, או השתמש בכלי היד",
    "linearElement": "לחץ להתחלת מספר נקודות, גרור לקו יחיד",
    "freeDraw": "לחץ וגרור, שחרר כשסיימת",
    "text": "טיפ: אפשר להוסיף טקסט על ידי לחיצה כפולה בכל מקום עם כלי הבחירה",
    "embeddable": "",
    "text_selected": "לחץ לחיצה כפולה או הקש על אנטר לעריכת הטקסט",
    "text_editing": "כדי לסיים את העריכה לחץ על מקש Escape או על Ctrl (Cmd במחשבי אפל) ומקש Enter",
    "linearElementMulti": "הקלק על הנקודה האחרונה או הקש Escape או Enter לסיום",
    "lockAngle": "ניתן להגביל את הזוויות על ידי החזקה של מקש ה- SHIFT",
    "resize": "ניתן להגביל פרופורציות על ידי לחיצה על SHIFT תוך כדי שינוי גודל,\nהחזק ALT בשביל לשנות גודל ביחס למרכז",
    "resizeImage": "אתה יכול לשנות את הגודל בחופשיות על ידי החזקת מקש SHIFT,\nהחזק את מקש ALT כדי לבצע שינוי גודל מהמרכז",
    "rotate": "ניתן להגביל זוויות על ידי לחיצה על SHIFT תוך כדי סיבוב",
    "lineEditor_info": "החזק Ctrl / Cmd ובצע לחיצה כפולה או לחץ Ctrl / Cmd + Enter לעריכת נקודות",
    "lineEditor_pointSelected": "לחץ Delete למחיקת נקודה/ות,\nCtrl / Cmd + D לשכפול, או גרור להזזה",
    "lineEditor_nothingSelected": "בחר נקודה כדי לערוך (החזק SHIFT לבחירת כמה),\nאו החזק Alt והקלק להוספת נקודות חדשות",
    "placeImage": "הקלק להנחת התמונה, או הקלק וגרור להגדרת הגודל שלו ידנית",
    "publishLibrary": "פרסם ספריה משלך",
    "bindTextToElement": "הקש Enter כדי להוספת טקסט",
    "deepBoxSelect": "החזק Ctrl / Cmd לבחירה עמוקה ולמניעת גרירה",
    "eraserRevert": "החזק Alt להחזרת רכיבים מסומנים למחיקה",
    "firefox_clipboard_write": "יכולות זה ניתנת להפעלה על ידי שינוי הדגל של \"dom.events.asyncClipboard.clipboardItem\" למצב \"true\". כדי לשנות את הדגל בדפדפן Firefox, בקר בעמוד ״about:config״.",
    "disableSnapping": ""
  },
  "canvasError": {
    "cannotShowPreview": "לא ניתן להראות תצוגה מקדימה",
    "canvasTooBig": "הקנבס עלול להיות גדול מדי.",
    "canvasTooBigTip": "טיפ: נסה להזיז את הרכיבים הרחוקים ביותר מעט קרוב יותר האחד לשני."
  },
  "errorSplash": {
    "headingMain": "",
    "clearCanvasMessage": "אם טעינה מחדש לא עובדת, נסה ",
    "clearCanvasCaveat": " זה יגרום לאובדן העבודה ",
    "trackedToSentry": "",
    "openIssueMessage": "",
    "sceneContent": "תוכן הקנבאס:"
  },
  "roomDialog": {
    "desc_intro": "אתה יכול להזמין אנשים לקנבאס הנוכחי שלך לעבודה משותפת.",
    "desc_privacy": "אל דאגה, השיתוף מוצפן מקצה לקצה, כך שכל מה שתצייר ישאר פרטי. אפילו השרתים שלנו לא יוכלו לראות את מה שאתה ממציא.",
    "button_startSession": "התחל שיתוף",
    "button_stopSession": "הפסק שיתוף",
    "desc_inProgressIntro": "שיתוף חי פעיל כרגע.",
    "desc_shareLink": "שתף את הקישור עם כל מי שאתה מעוניין לעבוד אתו:",
    "desc_exitSession": "עצירת השיתוף תנתק אותך מהחדר, אבל עדיין תוכל להמשיך לעבוד על הקנבאס, מקומית. שים לב שזה לא ישפיע על אנשים אחרים, והם עדיין יוכלו לבצע שיתוף עם הגרסה שלהם.",
    "shareTitle": "הצטרף לשיתוף לעבודה משותפת חיה, בזמן אמת, על גבי Excalidraw"
  },
  "errorDialog": {
    "title": "שגיאה"
  },
  "exportDialog": {
    "disk_title": "שמור לכונן",
    "disk_details": "ייצא מידע של הקנבאס לקובץ שתוכל לייבא אחר כך.",
    "disk_button": "שמירה לקובץ",
    "link_title": "קבל קישור לשיתוף",
    "link_details": "ייצוא כקישור לקריאה בלבד.",
    "link_button": "ייצוא לקישור",
    "excalidrawplus_description": "שמור את הקנבאס לסביבת העבודה שלך ב- +Excalidraw.",
    "excalidrawplus_button": "ייצוא",
    "excalidrawplus_exportError": "לא הצלחתי לייצא ל- +Excalidraw כרגע..."
  },
  "helpDialog": {
    "blog": "קרא את הבלוג שלנו",
    "click": "קליק",
    "deepSelect": "בחירה עמוקה",
    "deepBoxSelect": "בחירה עמוקה בתוך קופסה ומניעת גרירה",
    "curvedArrow": "חץ מעוגל",
    "curvedLine": "קו מעוגל",
    "documentation": "תיעוד",
    "doubleClick": "לחיצה כפולה",
    "drag": "גרור",
    "editor": "עורך",
    "editLineArrowPoints": "",
    "editText": "",
    "github": "מצאת בעיה? דווח",
    "howto": "עקוב אחר המדריכים שלנו",
    "or": "או",
    "preventBinding": "למנוע נעיצת חיצים",
    "tools": "כלים",
    "shortcuts": "קיצורי מקלדת",
    "textFinish": "סיים עריכה (עורך טקסט)",
    "textNewLine": "הוסף שורה חדשה (עורך טקסט)",
    "title": "עזרה",
    "view": "תצוגה",
    "zoomToFit": "זום להתאמת כל האלמנטים למסך",
    "zoomToSelection": "התמקד בבחירה",
    "toggleElementLock": "נעילה/ביטול הנעילה של הרכיבים הנבחרים",
    "movePageUpDown": "זוז עמוד למעלה/למטה",
    "movePageLeftRight": "זוז עמוד שמאלה/ימינה"
  },
  "clearCanvasDialog": {
    "title": "ניקוי הקנבס"
  },
  "publishDialog": {
    "title": "פרסם ספריה",
    "itemName": "שם הפריט",
    "authorName": "שם היוצר",
    "githubUsername": "שם המשתמש שלך ב-GitHub",
    "twitterUsername": "שם המשתמש שלך ב-Twitter",
    "libraryName": "שם הספריה",
    "libraryDesc": "תיאור הספריה",
    "website": "אתר",
    "placeholder": {
      "authorName": "שמך או שם המשתמש שלך",
      "libraryName": "תנו שם לספריה",
      "libraryDesc": "תיאור של הספריה שלך כדי לסייע למשתמשים להבין את השימוש בה",
      "githubHandle": "כינוי GitHub (לא חובה), כדי שתוכל לערוך את הספרית לאחר שנשלחה לבדיקה",
      "twitterHandle": "שם משתמש טוויטר (לא חובה), כדי שנדע למי לתת קרדיט כשאנחנו מפרסמים בטוויטר",
      "website": "קישור לאתר הפרטי שלך או לכל מקום אחר (אופציונאלי)"
    },
    "errors": {
      "required": "נדרש",
      "website": "הזינו כתובת URL תקינה"
    },
    "noteDescription": "",
    "noteGuidelines": "",
    "noteLicense": "",
    "noteItems": "לכל פריט בסיפריה חייב להיות שם כדי שאפשר יהיה לסנן. הפריטי סיפריה הבאים יהיו כלולים:",
    "atleastOneLibItem": "אנא בחר לפחות פריט אחד מספריה כדי להתחיל",
    "republishWarning": "הערה: חלק מהפריטים שבחרת מסומנים ככאלו שכבר פורסמו/נשלחו. אתה צריך לשלוח פריטים מחדש כאשר אתה מעדכן ספריה או הגשה קיימים."
  },
  "publishSuccessDialog": {
    "title": "הספריה הוגשה",
    "content": "תודה {{authorName}}. הספריה שלך נשלחה לבחינה. תוכל לעקוב אחרי סטטוס הפרסום"
  },
  "confirmDialog": {
    "resetLibrary": "איפוס ספריה",
    "removeItemsFromLib": "הסר את הפריטים הנבחרים מהספריה"
  },
  "imageExportDialog": {
    "header": "",
    "label": {
      "withBackground": "",
      "onlySelected": "",
      "darkMode": "",
      "embedScene": "",
      "scale": "",
      "padding": ""
    },
    "tooltip": {
      "embedScene": ""
    },
    "title": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    },
    "button": {
      "exportToPng": "",
      "exportToSvg": "",
      "copyPngToClipboard": ""
    }
  },
  "encrypted": {
    "tooltip": "הציורים שלך מוצפנים מקצה לקצה כך שהשרתים של Excalidraw לא יראו אותם לעולם.",
    "link": "פוסט בבלוג על הצפנה מקצה לקצב ב-Excalidraw"
  },
  "stats": {
    "angle": "זווית",
    "element": "רכיב",
    "elements": "רכיבים",
    "height": "גובה",
    "scene": "תצוגה",
    "selected": "נבחר",
    "storage": "אחסון",
    "title": "סטטיסטיקות לחנונים",
    "total": "סה״כ",
    "version": "גרסה",
    "versionCopy": "לחץ להעתקה",
    "versionNotAvailable": "הגרסה אינה זמינה",
    "width": "רוחב"
  },
  "toast": {
    "addedToLibrary": "נוסף לספריה",
    "copyStyles": "סגנונות הועתקו.",
    "copyToClipboard": "הועתק ללוח.",
    "copyToClipboardAsPng": "{{exportSelection}} הועתקה ללוח כ-PNG\n({{exportColorScheme}})",
    "fileSaved": "קובץ נשמר.",
    "fileSavedToFilename": "נשמר לקובץ {filename}",
    "canvas": "קנבאס",
    "selection": "בחירה",
    "pasteAsSingleElement": "השתמש ב- {{shortcut}} כדי להדביק כפריט יחיד,\nאו הדבק לתוך עורך טקסט קיים",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": ""
  },
  "colors": {
    "transparent": "שקוף",
    "black": "",
    "white": "",
    "red": "",
    "pink": "",
    "grape": "",
    "violet": "",
    "gray": "",
    "blue": "",
    "cyan": "",
    "teal": "",
    "green": "",
    "yellow": "",
    "orange": "",
    "bronze": ""
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "כל המידע שלח נשמר מקומית בדפדפן.",
      "center_heading_plus": "אתה רוצה ללכת אל Excalidraw+ במקום?",
      "menuHint": "ייצוא, העדפות, שפות, ..."
    },
    "defaults": {
      "menuHint": "ייצוא, העדפות, ועוד...",
      "center_heading": "איורים. נעשים. פשוטים.",
      "toolbarHint": "בחר כלי & והתחל לצייר!",
      "helpHint": "קיצורים & עזרה"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": ""
  }
}
